import { HomeDto, WarningsTolerance } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

const useWarningsTolerance = () => {
  const home = useSelector(
    (state: { global: { home: HomeDto } }) => state.global.home
  )

  const warningsTolerance = home.rotaSettings?.warningsTolerance

  const defaultToleranceSettings: WarningsTolerance = {
    durationMismatched: 10,
    clockOutEarly: 10,
    clockOutLate: 10,
    clockInEarly: 10,
    clockInLate: 30,
    missed: 0,
  }

  return warningsTolerance || defaultToleranceSettings
}

export default useWarningsTolerance
